App.filter('isOver69AtDateFromBirthdate', function () {
    return function (birthdayDate, specifiedDate) {
        birthdayDate = birthdayDate || '';
        if (birthdayDate) {
            birthdayDate = new Date(birthdayDate);
            var birthdayDateMilliseconds = new Date(birthdayDate.getFullYear() + 69, birthdayDate.getMonth(), birthdayDate.getDate()).getTime();
            specifiedDate = new Date(specifiedDate);
            var specifiedDateMilliseconds = new Date(specifiedDate.getFullYear(), specifiedDate.getMonth(), specifiedDate.getDate()).getTime();

            console.log(birthdayDateMilliseconds, specifiedDateMilliseconds, birthdayDateMilliseconds > specifiedDateMilliseconds, new Date(birthdayDate.getFullYear() + 69, birthdayDate.getMonth(), birthdayDate.getDate()));

        	return birthdayDateMilliseconds <= specifiedDateMilliseconds;
        } else {
        	return false;
        }
    };
});
